import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('tagStore')
@observer
class TagModify extends Component {

  render() {
    const { tagStore, params } = this.props;

    return (
      <ItemModify
      title='Tag'
      slug = '/tag'
      store = {tagStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text',readOnly:true, editOnly:true },
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default TagModify;



// WEBPACK FOOTER //
// ./src/components/Tag/TagModify.js